import React from "react";
import { createRoot } from "react-dom/client";
import { AppWithNav } from "./components/App/AppWithNav";

// Temporarily suppressing untranslated keys error coming from Platform
const consoleError = console.error.bind(console);
console.error = (message, ...args) => {
  if (message.code === "MISSING_TRANSLATION") {
    return;
  }
  consoleError(message, ...args);
};

const renderApp = (app) => {
  const container = document.getElementById("root");
  const root = createRoot(container);
  root.render(app);
};

const url = new URL(window.location.href);

if (url.pathname === "/signup-welcome") {
  const queryParams = new URLSearchParams(window.location.search);
  const token = queryParams.get("token");

  window.location.replace(
    `${process.env.REACT_APP_PUBLIC_CJ_URL}/signup/publisher?influencerToken=${token}`
  );
} else {
  renderApp(<AppWithNav />);
}
